document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.slider');

  sliders.forEach(slider => {
    if (window.innerWidth >= 750) {
      let scrollInterval;
      const sliderComponent = slider.closest('slider-component');
      const nextButton = sliderComponent.querySelector('.slider-button--next');

      const startAutoScroll = () => {
        clearInterval(scrollInterval);
        scrollInterval = setInterval(() => {
          // Check if we're on the last slide
          const currentSlide = slider.querySelector('.is-selected');
          const lastSlide = slider.lastElementChild;
          if (currentSlide === lastSlide) {
            // If on the last slide, scroll back to the beginning
            slider.scrollLeft = 0;
          } else {
            // Otherwise, click the next button to advance
            nextButton.click();
          }
        }, 2500); // Adjust scroll speed here (in milliseconds)
      };

      const stopAutoScroll = () => {
        clearInterval(scrollInterval);
      };

      sliderComponent.addEventListener('mouseenter', stopAutoScroll);
      sliderComponent.addEventListener('mouseleave', startAutoScroll);

      // Initially start the auto-scroll
      startAutoScroll();
    }
  });
});